import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import { DATE_PRESETS, getPresetRange } from './reportUtils';
import { cn } from '@/lib/utils';

export default function DateRangeFilter({ onChange, onExport, exportDisabled }) {
  const [preset, setPreset] = useState('This Month');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    if (preset !== 'Custom') {
      const range = getPresetRange(preset);
      setStart(range.start);
      setEnd(range.end);
      onChange(range.start, range.end);
    }
  }, [preset]);

  const handleCustomChange = (s, e) => {
    setStart(s);
    setEnd(e);
    onChange(s, e);
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div className="flex flex-wrap items-center gap-2">
        {DATE_PRESETS.map(p => (
          <button
            key={p}
            onClick={() => setPreset(p)}
            className={cn(
              "text-xs font-semibold px-3 py-1.5 rounded-lg border transition-colors",
              preset === p
                ? 'bg-primary text-primary-foreground border-primary'
                : 'border-border text-muted-foreground hover:text-foreground hover:border-border'
            )}
          >
            {p}
          </button>
        ))}
        {preset === 'Custom' && (
          <div className="flex items-center gap-2">
            <input type="date" value={start} onChange={e => handleCustomChange(e.target.value, end)}
              className="px-2 py-1 rounded-lg bg-transparent border border-input text-foreground text-xs" />
            <span className="text-muted-foreground text-xs">to</span>
            <input type="date" value={end} onChange={e => handleCustomChange(start, e.target.value)}
              className="px-2 py-1 rounded-lg bg-transparent border border-input text-foreground text-xs" />
          </div>
        )}
      </div>
      {onExport && (
        <button
          onClick={onExport}
          disabled={exportDisabled}
          className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/20 border border-primary/40 text-primary text-xs font-semibold hover:bg-primary/30 transition-colors disabled:opacity-40"
        >
          <Download className="w-3.5 h-3.5" /> Export CSV
        </button>
      )}
    </div>
  );
}